import React from "react";

export class HTML extends React.Component {
    rawMarkup() {
        var rawMarkup = this.props.content
        return { __html: rawMarkup };
    }
    render() {
        return (
            <div style={{ textAlign: "left", fontSize: "20px", textIndent:"18px", padding: "5px 0 5px 0", }}>
                <span dangerouslySetInnerHTML={this.rawMarkup()} />
            </div>
        )
    }
}